"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconReturn = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconReturn = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M24 23.994h-1.406c0-6.333-5.152-11.484-11.485-11.484h-.234v5.478L0 8.994 10.875 0v5.496C18.169 5.859 24 11.881 24 19.308v4.686zM9.469 11.104h1.64c5.03 0 9.29 2.856 11.416 6.888-.66-6.233-5.948-11.107-12.353-11.107h-.703V2.988L2.207 8.994 9.469 15v-3.897z"
}));
exports.IconReturn = IconReturn;
//# sourceMappingURL=IconReturn.js.map